/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFResolvedFinding } from './CRSFResolvedFinding';
import {
    CRSFResolvedFindingFromJSON,
    CRSFResolvedFindingFromJSONTyped,
    CRSFResolvedFindingToJSON,
} from './CRSFResolvedFinding';

/**
 * 
 * @export
 * @interface CRSFResolvedFindingsPagedResponse
 */
export interface CRSFResolvedFindingsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFResolvedFindingsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFResolvedFindingsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFResolvedFinding>}
     * @memberof CRSFResolvedFindingsPagedResponse
     */
    results?: Array<CRSFResolvedFinding>;
    /**
     * 
     * @type {number}
     * @memberof CRSFResolvedFindingsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFResolvedFindingsPagedResponse interface.
 */
export function instanceOfCRSFResolvedFindingsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFResolvedFindingsPagedResponseFromJSON(json: any): CRSFResolvedFindingsPagedResponse {
    return CRSFResolvedFindingsPagedResponseFromJSONTyped(json, false);
}

export function CRSFResolvedFindingsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFResolvedFindingsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFResolvedFindingFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFResolvedFindingsPagedResponseToJSON(value?: CRSFResolvedFindingsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFResolvedFindingToJSON)),
        'total': value.total,
    };
}

